import { twMerge } from 'tailwind-merge';
import modalStore from '../../../stores/modalStore';
import { observer } from 'mobx-react-lite';
import { XIcon } from 'lucide-react';

/**
 * 모달 하단 공통 액션 버튼
 */
export const ModalActionButton = observer(
    ({
        modalId,
        confirmStyle = 'default',
        isShowCancel = true,
        canConfirm = true,
        cancelText = '취소',
        confirmText = '확인',
        onCancel = () => {},
        onConfirm = () => {
            modalStore.setReturnValue(modalId, true);
        },
        className,
    }: {
        modalId: string;
        confirmStyle?: 'default' | 'danger';
        isShowCancel?: boolean;
        canConfirm?: boolean;
        cancelText?: string;
        confirmText?: string;
        /**
         * 취소 버튼 클릭 시 호출
         * - 기본값: 빈 하무
         */
        onCancel?: () => void;
        /**
         * 확인 버튼 클릭 시 호출
         * - 기본값: 확인 버튼을 누르면 모달을 닫고 true 를 반환
         * - 모달은 기본적으로 닫히고, 리턴값을 설정하려면 modalStore.setReturnValue(modalId, value) 를 호출해주면 됨
         */
        onConfirm?: () => void;
        className?: string;
    }) => {
        return (
            <div className={twMerge('modal-action px-5', className)}>
                <form method="dialog" className="flex w-full flex-row justify-end gap-2">
                    {isShowCancel && (
                        <button
                            className={twMerge('btn btn-action-outline h-10 min-w-20')}
                            onClick={() => {
                                onCancel?.();
                            }}
                        >
                            {cancelText}
                        </button>
                    )}
                    <button
                        className={twMerge(
                            'btn btn-action-neutral h-10 min-w-20',
                            confirmStyle === 'danger' && 'btn-action-danger',
                            !canConfirm && 'btn-disabled',
                        )}
                        disabled={!canConfirm}
                        onClick={() => {
                            if (!canConfirm) {
                                return;
                            }

                            if (onConfirm) {
                                onConfirm();
                            } else {
                                modalStore.setReturnValue(modalId, true);
                            }
                        }}
                    >
                        {confirmText}
                    </button>
                </form>
            </div>
        );
    },
);

/**
 * 모달 닫기 버튼
 */
export const ModalCloseXButton = observer(() => {
    return (
        <form method="dialog">
            <button className="btn btn-sm btn-circle btn-ghost text-base-content/60 absolute top-2 right-2">
                <XIcon className="size-5" />
            </button>
        </form>
    );
});
